/* eslint-disable no-restricted-syntax */
/* eslint-disable no-nested-ternary */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {onlyToast} from 'hiya-common/src/App/CustomToaster'
import {getGameId, setLocalMusic} from './constant'
import {SPORTTAB, RoundStatus, WinType, RESULTSTATUS, RepeatFlag, FootballCupPhase} from './interface'
import {
  getMockFootballCupTeamRankResult as getMockFootballCupTeamRankResultFromMock,
  mockFootballCupHomepageData as mockFootballCupHomepageDataFromMock,
  mockFootballCupStatusData as mockFootballCupStatusDataFromMock,
  mockFootballCupTaskInfoData as mockFootballCupTaskInfoDataFromMock,
  USE_MOCK_FOOTBALL_CUP_TEAM_RANK,
} from './mockdata'

export async function uploadImg(params: Record<string, unknown>) {
  const resp = await http.post('/live/misc/upload_img', {
    ...params,
    ...window.store.getState().env.deviceinfo,
  })
  return resp.data.data
}

// 主页 http://wiki.xunlei.cn/pages/viewpage.action?pageId=179495909
export const greedy_sports_homepage = createAsyncThunk(
  '/live/ground/gy_s_homepage',
  async (arg: {mode?: SPORTTAB}, store: any) => {
    const {deviceinfo, path} = store.getState().env
    const {tab} = store.getState().Animal_Horse?.config || {}
    const resp = await http.post(
      '/live/ground/gy_s_homepage',
      {
        mode: tab,
        ...arg,
        ...deviceinfo,
        config_id: getGameId(path),
        room_id: deviceinfo.h_web_room_id,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 下注 http://wiki.xunlei.cn/pages/viewpage.action?pageId=179495927
// status 1 下注成功 2 下注失败
export const greedy_sports_bet = createAsyncThunk(
  '/live/ground/gy_s_bet',
  async (
    arg: {
      mode: SPORTTAB
      target_id?: number
      bet_coins?: number
      is_repeat?: boolean
    },
    store: any
  ) => {
    const {deviceinfo, path} = store.getState().env
    const resp = await http.post(
      '/live/ground/gy_s_bet',
      {
        ...arg,
        ...deviceinfo,
        config_id: getGameId(path),
        room_id: deviceinfo.h_web_room_id,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 结果接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=179495939
export const greedy_sports_result = createAsyncThunk(
  'greedy_sports_result',
  async (arg: {mode: SPORTTAB; round_no: string}, store: any) => {
    // 每次获取开奖结果的时候将之前的结果清空
    const {deviceinfo, path} = store.getState().env
    const resp = await http.post(
      '/live/ground/gy_s_result',
      {
        config_id: getGameId(path),
        room_id: deviceinfo.h_web_room_id,
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 足球赛事 banner / 杯赛状态 http://wiki（football_cup_status）
export const football_cup_status = createAsyncThunk<FootballCupStatusData, void | {config_id?: number}>(
  '/live/game/football_cup_status',
  async (arg, store: any) => {
    const {deviceinfo, path} = store.getState().env
    const override = arg && typeof arg === 'object' ? arg.config_id : undefined
    const resp = await http.post(
      '/live/game/football_cup_status',
      {
        ...deviceinfo,
        config_id: override ?? getGameId(path),
        room_id: deviceinfo.h_web_room_id,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data as FootballCupStatusData
  }
)

// 足球杯赛首页聚合 http://wiki（football_cup_homepage）
export const football_cup_homepage = createAsyncThunk<FootballCupHomepageData, void | {config_id?: number}>(
  '/live/game/football_cup_homepage',
  async (arg, store: any) => {
    const {deviceinfo, path} = store.getState().env
    const override = arg && typeof arg === 'object' ? arg.config_id : undefined
    const resp = await http.post(
      '/live/game/football_cup_homepage',
      {
        ...deviceinfo,
        config_id: override ?? getGameId(path),
        room_id: deviceinfo.h_web_room_id,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data as FootballCupHomepageData
  }
)

// 足球赛事任务 http://wiki（football_cup_task_info）
export const football_cup_task_info = createAsyncThunk<FootballCupTaskInfoData, void | {config_id?: number}>(
  '/live/game/football_cup_task_info',
  async (arg, store: any) => {
    const {deviceinfo, path} = store.getState().env
    const override = arg && typeof arg === 'object' ? arg.config_id : undefined
    const resp = await http.post(
      '/live/game/football_cup_task_info',
      {
        ...deviceinfo,
        config_id: override ?? getGameId(path),
        room_id: deviceinfo.h_web_room_id,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data as FootballCupTaskInfoData
  }
)

/** 足球赛事选择球队 POST /live/game/football_cup_choose_team */
export interface FootballCupChooseTeamResult {
  err_msg?: string
  /** 1 成功，2 重复选择 */
  status: number
}

export const football_cup_choose_team = createAsyncThunk<
  FootballCupChooseTeamResult,
  {config_id: number; team_id: number; inviter?: number}
>('/live/game/football_cup_choose_team', async (arg, store: any) => {
  const {deviceinfo} = store.getState().env
  const payload: Record<string, unknown> = {
    ...deviceinfo,
    config_id: arg.config_id,
    team_id: arg.team_id,
    room_id: deviceinfo.h_web_room_id,
  }
  if (arg.inviter != null && Number.isFinite(arg.inviter) && arg.inviter > 0) {
    payload.inviter = arg.inviter
  }
  const resp = await http.post('/live/game/football_cup_choose_team', payload, {
    store,
    xcErrorToast: true,
  })
  return resp.data.data as FootballCupChooseTeamResult
})

export interface FootballCupActivityMember {
  id: number
  name: string
  zy_id: string
  avatar: string
  stealth?: boolean
}

/** POST /live/game/football_cup_team_rank — 球队内成员排行榜 */
export interface FootballCupTeamRankItem {
  rank_no: number
  points: number
  member: FootballCupActivityMember
}

export interface FootballCupTeamRankResult {
  err_msg?: string
  list: FootballCupTeamRankItem[]
}

export const football_cup_team_rank = createAsyncThunk<FootballCupTeamRankResult, {config_id: number; team_id: number}>(
  '/live/game/football_cup_team_rank',
  async (arg, store: any) => {
    if (USE_MOCK_FOOTBALL_CUP_TEAM_RANK) {
      return getMockFootballCupTeamRankResultFromMock(arg.team_id) as FootballCupTeamRankResult
    }
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/football_cup_team_rank',
      {
        ...deviceinfo,
        config_id: arg.config_id,
        team_id: arg.team_id,
        room_id: deviceinfo.h_web_room_id,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data as FootballCupTeamRankResult
  }
)

export interface FootballCupPhaseItem {
  phase: FootballCupPhase
  begin_ts: number
  end_ts: number
}

export interface FootballCupPhaseInfo {
  phase_list: FootballCupPhaseItem[]
  current_phase: FootballCupPhase
  /** 当前阶段倒计时（秒） */
  countdown: number
}

export interface FootballCupTeamItem {
  team_id: number
  name: string
  icon: string
}

export interface FootballCupUserInfo {
  team_id: number
  team_rank_no: number
  team_size: number
  is_eliminated: boolean
  wasted_coins: number
  member: FootballCupActivityMember
  my_rank_no: number
  my_points: number
}

export interface FootballCupPoolInfo {
  jackpot_pool_coins: number
  top_team_pool_coins: number
}

export interface FootballCupWinnerInfo {
  rank_no: number
  team_id: number
  /** 接口无队内贡献榜首时为 `null` */
  top_contributor: FootballCupActivityMember | null
}

export interface FootballCupStatusData {
  err_msg?: string
  /** 接口偶发为 `null`，store / 映射层需兜底 */
  phase: FootballCupPhaseInfo | null
  teams: FootballCupTeamItem[]
  /** 接口偶发缺失时用 `null`，映射层需兜底 */
  user: FootballCupUserInfo | null
  /** 接口偶发为 `null`，store / 映射层需兜底 */
  pool: FootballCupPoolInfo | null
  winners: FootballCupWinnerInfo[]
}

export interface FootballCupPrizeItem {
  icon: string
  name: string
}

export interface FootballCupWheelInfo {
  /** 倒计时（秒） */
  countdown: number
  mini_jackpot_pool: number
  minor_jackpot_pool: number
  major_jackpot_pool: number
}

export interface FootballCupRankInfo {
  rank_no: number
  team_id: number
  team_name: string
  team_icon: string
  points: number
  prizes: FootballCupPrizeItem[]
  pool_coins: number
  /** 进入前三名所需积分（展示用阈值） */
  top_need_points: number
}

export interface FootballCupHomepageData {
  err_msg?: string
  /** 接口偶发为 `null`，store / 映射层需兜底 */
  phase: FootballCupPhaseInfo | null
  /** 接口偶发为 `null`，store / 映射层需兜底为 `[]` */
  teams?: FootballCupTeamItem[] | null
  /** 接口偶发缺失时用 `null`，映射层需兜底 */
  user: FootballCupUserInfo | null
  /** 接口偶发为 `null`，store / 映射层需兜底 */
  wheel: FootballCupWheelInfo | null
  /** 接口偶发为 `null`，store / 映射层需兜底为 `[]` */
  rank?: FootballCupRankInfo[] | null
  is_share_done: boolean
  push_select: boolean
  min_settle_points: number // 瓜分奖池积分门槛
}

/** 任务类型：`1` 分享站外 · `2` 邀请加入球队 · `3` 邀请新用户 */
export type FootballCupTaskType = 1 | 2 | 3

export interface FootballCupTaskInfo {
  task_type: FootballCupTaskType
  /** 每日完成上限 */
  daily_limit: number
  /** 当日/累计已完成次数（以服务端为准） */
  finished: number
  points_reward: number
  ticket_reward: number
  first_extra_ticket: number
  first_rewarded: boolean
}

export interface FootballCupTaskInfoData {
  err_msg?: string
  list: FootballCupTaskInfo[]
}

export const createEmptyFootballCupPhaseInfo = (): FootballCupPhaseInfo => ({
  phase_list: [],
  current_phase: FootballCupPhase.NotStarted,
  countdown: 0,
})

/** `/football_cup_status` 回填：合并初始占位，避免 `phase`/`pool` 等为 `null` 导致 UI 崩溃 */
export function normalizeFootballCupStatusData(
  payload: Partial<FootballCupStatusData> | null | undefined
): FootballCupStatusData {
  const base = initialFootballCupStatusData
  if (!payload) return {...base}
  const phase = payload.phase ?? base.phase
  return {
    err_msg: payload.err_msg ?? base.err_msg,
    phase: {
      phase_list: phase.phase_list ?? [],
      current_phase: phase.current_phase ?? base.phase.current_phase,
      countdown: phase.countdown ?? 0,
    },
    teams: payload.teams ?? [],
    user: payload.user ?? base.user,
    pool: payload.pool ?? base.pool,
    winners: normalizeFootballCupWinners(payload.winners),
  }
}

/** `/football_cup_homepage` 回填：合并初始占位 */
export function normalizeFootballCupHomepageData(
  payload: Partial<FootballCupHomepageData> | null | undefined
): FootballCupHomepageData {
  const base = initialFootballCupHomepageData
  if (!payload) return {...base}
  const phase = payload.phase ?? base.phase
  return {
    err_msg: payload.err_msg ?? base.err_msg,
    phase: {
      phase_list: phase.phase_list ?? [],
      current_phase: phase.current_phase ?? base.phase.current_phase,
      countdown: phase.countdown ?? 0,
    },
    teams: payload.teams ?? [],
    user: payload.user ?? base.user,
    wheel: payload.wheel ?? base.wheel,
    rank: payload.rank ?? [],
    is_share_done: payload.is_share_done ?? base.is_share_done,
    push_select: payload.push_select ?? base.push_select,
    min_settle_points: payload.min_settle_points ?? base.min_settle_points,
  }
}

export function createEmptyFootballCupUserInfo(): FootballCupUserInfo {
  return {
    team_id: 0,
    team_rank_no: 0,
    team_size: 0,
    is_eliminated: false,
    wasted_coins: 0,
    member: {id: 0, name: '', zy_id: '', avatar: ''},
    my_rank_no: 0,
    my_points: 0,
  }
}

/** 接口 `winners` 偶发缺失或 `top_contributor` 为 `null` 时统一兜底 */
export function normalizeFootballCupWinners(
  winners: FootballCupWinnerInfo[] | null | undefined
): FootballCupWinnerInfo[] {
  return (winners ?? []).map((w) => ({
    rank_no: w.rank_no,
    team_id: w.team_id,
    top_contributor: w.top_contributor ?? null,
  }))
}

export const initialFootballCupStatusData: FootballCupStatusData = {
  err_msg: '',
  phase: createEmptyFootballCupPhaseInfo(),
  teams: [],
  user: createEmptyFootballCupUserInfo(),
  pool: {jackpot_pool_coins: 0, top_team_pool_coins: 0},
  winners: [],
}

export const initialFootballCupHomepageData: FootballCupHomepageData = {
  err_msg: '',
  phase: createEmptyFootballCupPhaseInfo(),
  teams: [],
  user: createEmptyFootballCupUserInfo(),
  wheel: {
    countdown: 0,
    mini_jackpot_pool: 0,
    minor_jackpot_pool: 0,
    major_jackpot_pool: 0,
  },
  rank: [],
  is_share_done: false,
  push_select: false,
  min_settle_points: 0,
}

export const initialFootballCupTaskInfoData: FootballCupTaskInfoData = {
  err_msg: '',
  list: [],
}

/** football_cup_status 本地假数据：mockdata.js 同源；显式引用，非 store 默认 */
export const mockFootballCupStatusData = mockFootballCupStatusDataFromMock as FootballCupStatusData

/** football_cup_homepage 本地假数据：mockdata.js 同源；显式引用，非 store 默认 */
export const mockFootballCupHomepageData = mockFootballCupHomepageDataFromMock as FootballCupHomepageData

/** football_cup_task_info 本地假数据：mockdata.js 同源；显式引用，非 store 默认 */
export const mockFootballCupTaskInfoData = mockFootballCupTaskInfoDataFromMock as FootballCupTaskInfoData

interface normal_target_res_type {
  target_id: number // 目标ID
  odds: number // 中奖赔率
  hot_topn: number // 热榜排名
  bet_amounts: number // 下注金额
  total_bet: number // 总下注金额
}

export interface round_res_type {
  round_no: string // 轮次唯一性ID
  target_id: number // 中奖标的ID
}

interface round_rank_type {
  zy_id: string // 用户ID
  name: string // 用户名称
  avatar: string // 用户头像
  rank_no: number // 排名
  coin_nums: number // 中奖金额
}

interface InitialStateType {
  // 本地控制
  config?: {
    tab: SPORTTAB
    isGuide?: boolean // 新手引导标志
    /** 每一时刻的引导进度，引导不存在时为 null */
    guideProgress?: number | null
    hasPreLoadedAct?: boolean // 前置加载引导标志
    isLoading?: boolean // 加载标志
    playMusic?: boolean // 播放音乐
    bet_num?: number // 下注金额
    bet_lock?: boolean // 下注控制
    auto_hold_spin?: boolean // 是否是自动hold_spin
    /** 足球射门动画进行中，与场景 shotInProgress 同步，用于禁用射门按钮 */
    shotInProgress?: boolean
  }
  // home接口信息
  home?: {
    config_id?: number // 配置ID
    round_bet_limit: number // 每轮最大下注金额
    round_no: string // 当前轮次唯一性ID
    day_round: number // 当前轮次/日
    coin_num: number // 金币余额
    today_win: number // 今日赢钱总数
    target_list: Array<normal_target_res_type> // 目标列表
    round_status: RoundStatus
    round_target: number // 本轮的中奖标的ID,
    status_expire: number // 当前状态的剩余时间: 秒数
    bet_prices: Array<number> // 单次可下注金额列表
    default_bet_price: number // 默认下注金额
    history_result: Array<round_res_type> // 历史结果列表
    ui_config?: any
    /** 重复下注状态码，见 RepeatFlag 枚举 */
    repeat_flag?: RepeatFlag
    betted?: boolean // 是否下注
    // 长链接 245下发信息
    // 开奖时 未开奖没有结果信息
    // config_id?: number // 配置ID
    // round_no: string // 当前轮次唯一性ID
    status?: RoundStatus // 当前状态:0:下注阶段; 30s 1:开奖中阶段; 4s 2:开奖结果展示阶段 6s
    // status_expire: number // 当前状态的剩余时间: 秒数
    normal_result?: {
      hit_target: number // 命中的目标ID
      is_shoot: boolean // 是否射门
      shoot_hits: Array<number> // 射门命中列表
    }
    advanced_result?: {
      hit_target: number // 命中的目标ID
      is_shoot: boolean // 是否射门
      shoot_hits: Array<number> // 射门命中列表
    }
    master_result?: {
      hit_target: number // 命中的目标ID
      is_shoot: boolean // 是否射门
      shoot_hits: Array<number> // 射门命中列表
    }
    rank_flag?: boolean // 榜单红点
  }
  // result接口信息
  result?: {
    round_no: string // 轮次唯一性ID
    status: RESULTSTATUS // 本轮结果状态: 0:未参与;1:参与但失败;2:参与并获胜
    bet_coins: number // 本轮下注总金额
    reward_coins: number // 本轮中奖金额
    round_target: number // 本轮中奖标的ID
    round_rank: Array<round_rank_type> // 本轮中奖金额top3
    is_shoot: boolean // 是否射门
    shoot_hits: Array<number> // 射门命中列表
    win_type: WinType // 赢取类型:1:普通奖 2:大奖（多个图标）
  }
  preResult?: {
    round_no: string // 轮次唯一性ID
    status: RESULTSTATUS // 本轮结果状态: 0:未参与;1:参与但失败;2:参与并获胜
    bet_coins: number // 本轮下注总金额
    reward_coins: number // 本轮中奖金额
    round_target: number // 本轮中奖标的ID
    round_rank: Array<round_rank_type> // 本轮中奖金额top3
    is_shoot: boolean // 是否射门
    shoot_hits: Array<number> // 射门命中列表
    win_type: WinType // 赢取类型:1:普通奖 2:大奖（多个图标）
  }
  /** 足球杯赛 banner /football_cup_status 数据 */
  footballCup?: FootballCupStatusData
  /** 足球杯赛首页 /football_cup_homepage 数据 */
  footballCupHomepage?: FootballCupHomepageData
  /** 足球赛事任务 /football_cup_task_info 数据 */
  footballCupTaskInfo?: FootballCupTaskInfoData
}
const initData = {
  // 本地控制
  config: {
    isGuide: false,
    guideProgress: null as number | null,
    hasPreLoadedAct: false,
    isLoading: true,
    playMusic: true,
    bet_num: 0,
    bet_lock: false,
    tab: SPORTTAB.Normal,
  },
  // home接口信息
  home: {
    default_bet_price: 500,
  },
  result: {},
  footballCup: initialFootballCupStatusData,
  footballCupHomepage: initialFootballCupHomepageData,
  footballCupTaskInfo: initialFootballCupTaskInfoData,
}
const initialState: InitialStateType = {
  config: {
    tab: SPORTTAB.Normal,
    guideProgress: null,
  },
  footballCup: initialFootballCupStatusData,
  footballCupHomepage: initialFootballCupHomepageData,
  footballCupTaskInfo: initialFootballCupTaskInfoData,
}

// =============== 长链接数据处理
const messageReducers = {
  // 更新长链接信息 handle245 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612536
  updateMessageInfo: (state, action) => {
    const {status} = action.payload
    const {target_list} = state.home || {}
    Object.assign(state.home, {
      ...action.payload,
      round_status: status,
      target_list:
        status === RoundStatus.Bet
          ? target_list?.map((ite) => {
              return {...ite, bet_amounts: 0, total_bet: 0, hot_topn: 0}
            })
          : target_list,
    })
  },
  // 长链接下注数据：仅用 new_target_list 的 hot_topn、total_bet 更新现有 target_list，不覆盖 odds、bet_amounts 等
  updateBetInfo: (state, action) => {
    const target_list = state?.home?.target_list
    if (!target_list?.length) return
    const tab = state.config?.tab || SPORTTAB.Normal
    const {normal_targets, advanced_targets, master_targets} = action.payload || {}
    const new_target_list =
      tab === SPORTTAB.Advanced ? advanced_targets : tab === SPORTTAB.Master ? master_targets : normal_targets
    if (!new_target_list?.length) return
    for (const item of target_list) {
      const newItem = new_target_list.find((f) => f.target_id === item.target_id)
      item.hot_topn = newItem?.hot_topn ?? 0
      item.total_bet = newItem?.total_bet ?? 0
    }
  },
}

// ============== 功能设置型reducer
const configReducers = {
  // 改变重复下注标志
  changeRepeatFlag: (state, action) => {
    Object.assign(state.home, {
      repeat_flag: action.payload,
    })
  },
  // tab切换
  changeTab: (state, action) => {
    Object.assign(state.config, {
      tab: action.payload,
    })
  },
  // 前置流程完成标记
  finishedPreLoadedAct: (state) => {
    Object.assign(state.config, {
      hasPreLoadedAct: true,
    })
  },
  // 引擎加载完毕之后隐藏加载页面
  finishedLoading: (state) => {
    Object.assign(state.config, {
      isLoading: false,
    })
  },
  // 切换音效（并持久化到 storage）
  ChangePlayMusic: (state) => {
    const next = !state.config.playMusic
    Object.assign(state.config, {playMusic: next})
    setLocalMusic(next)
  },
  // 改变下注金额
  changeBet: (state, action) => {
    // 处于免费玩不能更改下注
    if (!state?.config?.bet_lock) {
      Object.assign(state.config, {
        bet_num: action.payload,
      })
    }
  },
  // 新手引导
  setGuide: (state, action) => {
    Object.assign(state.config, {
      isGuide: action.payload,
    })
  },
  // 每一时刻的引导进度，引导不存在时为 null
  setGuideProgress: (state, action: PayloadAction<number | null>) => {
    Object.assign(state.config, {
      guideProgress: action.payload,
    })
  },
  // 足球射门动画进行中（与 Phaser 场景 shotInProgress 同步）
  setShotInProgress: (state, action: PayloadAction<boolean>) => {
    Object.assign(state.config, {
      shotInProgress: action.payload,
    })
  },
}

export const GreedySportsSlice = createSlice({
  name: 'Animal_Horse',
  initialState,
  reducers: {
    ...messageReducers,
    ...configReducers,
    initData: (state, action) => {
      Object.assign(state, initData)
    },
  },
  extraReducers: (builder) => {
    // 主页
    builder.addCase(greedy_sports_homepage.fulfilled, (state, action) => {
      const {target_list} = action.payload
      // 默认的是否下注 是否的
      let betted = false
      betted = target_list?.some((f) => f.bet_amounts > 0)
      Object.assign(state.home, {
        ...action.payload,
        betted,
      })
    })
    builder.addCase(greedy_sports_bet.fulfilled, (state, action) => {
      const {target_list, status} = action.payload
      // 默认的是否下注 是否的
      let betted = false
      betted = target_list?.some((f) => f.bet_amounts > 0)
      if (status === RESULTSTATUS.success) {
        Object.assign(state.home, {
          ...action.payload,
          target_list: target_list || state?.home?.target_list,
          betted,
        })
      }
    })
    builder.addCase(greedy_sports_result.fulfilled, (state, action) => {
      Object.assign(state.result, {
        ...action.payload,
      })
    })
    builder.addCase(football_cup_status.fulfilled, (state, action) => {
      state.footballCup = normalizeFootballCupStatusData(action.payload)
    })
    builder.addCase(football_cup_homepage.fulfilled, (state, action) => {
      state.footballCupHomepage = normalizeFootballCupHomepageData(
        action.payload
      )
    })
    builder.addCase(football_cup_task_info.fulfilled, (state, action) => {
      const payload = action.payload
      state.footballCupTaskInfo = {
        ...payload,
        list: payload.list ?? [],
      }
    })
  },
})

export const GreedySportsActions = GreedySportsSlice.actions
export const useGreedySports = () => {
  return useSelector((state) => state.Animal_Horse)
}
export default GreedySportsSlice.reducer
